// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__ROQQ7","cardTitle":"ActiveCustomers_cardTitle__6Iy+4","chart":"ActiveCustomers_chart__AsRUp"};